import React, { useState } from 'react'
import { Box } from 'ui-components'
import SearchCompanyWithSic from '../../../../components/search-company-with-sic'
import SicCodeMultiSelect from './sics-codes'
import { FormDataT } from '../../../../utils/constants'

const SearchSicWithName = ({
	setCompanyIdBySic,
	setFormData
}:{
	setCompanyIdBySic :(e:string) => void,
	setFormData: (e:FormDataT) => void
}) => {
	const [sicCodes,setSicCodes] = useState<string[]>([]);
	return (
		<Box flexDir="row" gap={"medium"}>
			<Box flex="2/3">
				<SicCodeMultiSelect
					values={sicCodes}	
					setValues={setSicCodes}
				/>
			</Box>
			<Box flex="1/2"><SearchCompanyWithSic sicCodes={sicCodes} placeholder='search with sic' setFormData={setFormData}/></Box>
		</Box>
	)
}

export default SearchSicWithName